
// import { useApiStore } from '@/stores/apiStore'
import { defineComponent } from "vue";
import { FormatBytes } from "@/utils/Utilities";
import { ISitesListTableFormatUIFormat } from "@/types/sites";
// import moment from 'moment-timezone';
// import { storeToRefs } from 'pinia'
// import { useRouter } from 'vue-router'
// import { useAuthStore } from '@/stores/authStore';

export default defineComponent({
	name: "imdex-data-usage",
	props: {
		items: {
			type: Array as () => ISitesListTableFormatUIFormat[],
			default: () => [] as ISitesListTableFormatUIFormat[]
		},
		containerSize: {
			Type: Number,
			default: 400000000
		}
	},
	setup() {
		const formatBytes = FormatBytes;

		return { formatBytes };
	},
	computed: {
		storageSpaceRemaining() {
			// eslint-disable-next-line
			const itemSize: any = this.items.reduce((value, item: any) => {
				return value + item.size;
			}, 0);
			return this.containerSize - itemSize;
		}
	}
});
